import { MenuItem, TextField } from '@mui/material';
import { businessForms } from '../../../../../constants';

type BusinessFormInputProps = {
  value: number;
  onChange: (value: number) => void;
};

export function BusinessFormInput({ value, onChange }: BusinessFormInputProps) {
  return (
    <TextField
      select
      label='Rechtsform'
      size='small'
      fullWidth
      value={value}
      onChange={event => onChange(Number(event.target.value))}
    >
      <MenuItem key={`idBusinessForm-null}`} value={-1}>
        <i>Keine Rechtsform zugeordnet</i>
      </MenuItem>
      {businessForms.map(businessForm => (
        <MenuItem
          key={`idBusinessForm-${businessForm.idBusinessForm}`}
          value={businessForm.idBusinessForm}
        >
          {businessForm.BusinessForm}
        </MenuItem>
      ))}
    </TextField>
  );
}
